import { graphql } from "msw";

import { CartContextQuery } from "@common-vendors/generated/graphql";
import { mockCartContext } from "@common-vendors/mocks/data";

export const handler = graphql.query<CartContextQuery>(
  "CartContext",
  (_req, res, ctx) => {
    return res(
      ctx.data({
        cart: mockCartContext,
      })
    );
  }
);
